export default __webpack_public_path__ + "static/media/groovy-ale.2a876e91.jpg";